<template>
  <section class="section">

     <div class="columns">
       <div class="column">
        <title-bar>
      Welcome, {{ nameOfUser }}!
      <!-- <a href="https://admin-two.justboil.me" class="button is-primary" slot="button">
        Switch to Premium demo
      </a>-->
    </title-bar>
       </div>
       <div class="column">
       <a title="Log out" @click="logout">
          <i style="color: white; padding-right: 20px ">
            <b-icon pack="fas" icon="sign-out-alt" pxcustom-size="default" />
          </i>

          <button class="button is-danger" style="float:right">Log out</button>
        </a>
       </div>
     </div> 
    <tiles>
      <div class="columns column-div">
        <div class="column">
          <div class="col-items">
      <card-widget
        class="tile is-child"
        type="is-primary"
        icon="users"
        :number="dashboard.citizenCount"
        label="Shareholders"
      />
          </div>
          <div class="col-items">
      <card-widget
        class="tile is-child"
        type="is-primary"
        icon="crosshairs"
        :number="dashboard.citizenPCount"
        label="Pending Shareholders"
      />
          </div>
          <div class="col-items">
      <card-widget
      v-if="(roleofUser == 0 ||roleofUser == 1 ||roleofUser == 4)"
        class="tile is-child"
        type="is-primary"
        icon="tasks"
        :number="dashboard.userACount"
        suffix
        label="Admin"
      />
      </div>
      <div class="col-items">
      <card-widget
        v-if="roleofUser == 0"
        class="tile is-child"
        type="is-primary"
        icon="user-secret"
        :number="dashboard.userCount"
        suffix
        label="Super Admin"
      />
      </div>
          
        </div>
        <div class="column">
          <div class="col-items">
      <card-widget
        class="tile is-child"
        type="is-primary"
        icon="check"
        :number="dashboard.citizenVCount"
        label="Verified Shareholders"
      />
          </div>
          <div class="col-items">
      <card-widget
      v-if="(roleofUser == 0 || roleofUser == 1 || roleofUser == 4)"
        class="tile is-child"
        type="is-primary"
        icon="tasks"
        :number="dashboard.userDcCount"
        suffix
        label="Data Clerks"
      />
      </div>
      <div class="col-items">
      <card-widget
        class="tile is-child"
        type="is-primary"
        icon="address-card"
        :number="dashboard.citizenTUCount"
        label="Registered Today"
      />
        </div>
        </div>
      <div class="column ">
        <div class="col-items">
      <card-widget
        class="tile is-child"
        type="is-primary"
        icon="asterisk"
        :number="dashboard.citizenUCount"
        label="Unverified Shareholders"
      />
          </div>
        
      <div class="col-items">
      <card-widget
      v-if="(roleofUser == 0 || roleofUser == 1 || roleofUser == 4)"
        class="tile is-child"
        type="is-primary"
        icon="tasks"
        :number="dashboard.userDCount"
        suffix
        label="Data Admin"
      />
      </div>
      <div class="col-items">
       <card-widget
        class="tile is-child"
        type="is-primary"
        icon="id-badge"
        :number="dashboard.citizenTVCount"
        label="Verified Today"
      />
      </div>
      </div>
      </div>
    </tiles>
    <!-- <div>
       <a title="Log out" @click="logout">
          <i style="color: white; padding-right: 20px ">
            <b-icon pack="fas" icon="sign-out-alt" pxcustom-size="default" />
          </i>

          <span style="color: white">Log out</span>
        </a>
  </div> -->


    <!-- <tiles>
      <card-widget
        class="tile is-child"
        type="is-primary"
        icon="users"
        :number="dashboard.userCount"
        label="Users"
      />
      <card-widget
        class="tile is-child"
        type="is-primary"
        icon="sitemap"
        :number="dashboard.companyCount"
        prefix
        label="Companies"
      />
      <card-widget
        class="tile is-child"
        type="is-primary"
        icon="american-sign-language-interpreting"
        :number="dashboard.monthIncome"
        suffix
        label="Income"
      />
      <card-widget
        class="tile is-child"
        type="is-primary"
        icon="arrow-circle-down"
        number="23600"
        suffix
        label="Expenses"
      />
    </tiles>-->

    <!-- <card-component
      title="Performance"
      @header-icon-click="fillChartData"
      icon="finance"
      header-icon="reload"
    >
      <div v-if="defaultChart.chartData" class="chart-area">
        <line-chart
          style="height: 100%"
          ref="bigChart"
          chart-id="big-line-chart"
          :chart-data="defaultChart.chartData"
          :extra-options="defaultChart.extraOptions"
        ></line-chart>
      </div>
    </card-component>-->
    <card-component v-if="role == 'admin'" class="has-table">
      <div class="columns is-mobile">
  <div class="column is-half is-offset-one-quarter">  <clients-table-sample />
  
  </div>
  
 
</div>


    </card-component>

    
  </section>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import * as chartConfig from '@/components/Charts/chart.config';
import CardComponent from '@/components/CardComponent';
import Tiles from '@/components/Tiles';
import CardWidget from '@/components/CardWidget';
// import LineChart from '@/components/Charts/LineChart';
import ClientsTableSample from '@/components/ClientsTableSample';
import TitleBar from '@/components/TitleBar';
import LogoutModalBox from '../components/Home/LogoutModalBox';

export default {
  name: 'home',
  components: {
    TitleBar,
    ClientsTableSample,
    CardWidget,
    Tiles,
    CardComponent,
    // LogoutModalBox
    // LineChart,
  },
  data() {
    return {
      defaultChart: {
        chartData: null,
        extraOptions: chartConfig.chartOptionsMain,
      },
      noOfOnlineUser: 0,
      totalExpenses: 23600,
      totalIncome: 72000,
      role: ''
    };
  },

  computed: {
    dashboard() {
      return this.$store.state.dashboard.dashboard;
    },
    nameOfUser() {
      return this.$store.state.auth.user ? this.$store.state.auth.user.name : '';
    },
    roleofUser() {
      return this.$store.state.auth.user?  this.$store.state.auth.user.role : 99
    }
    
  },
  mounted() {
    this.fillChartData();

    this.role = localStorage.getItem('role');

    this.$buefy.snackbar.open({
      message: 'Welcome back',    
      queue: false,
    });
    this.$store.commit('isNavBarVisible', true);
  },
  created() {
    // this.$onSocket.on('onOnlineUserListUpdate', (res) => {
    //   this.noOfOnlineUser = res;
    //   console.log(res);
    // });

    this.$store.dispatch('dashboard/getDashboard');
  },
  // destroyed() {
  //   this.$socket.removeListener('onOnlineUserListUpdate');
  // },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ path: '/login' });
        this.$buefy.snackbar.open({
          message: 'Logged Out Successfully',
          queue: false,
        });
      });
    },
    randomChartData(n) {
      let data = [];

      for (let i = 0; i < n; i++) {
        data.push(Math.round(Math.random() * 200));
      }

      return data;
    },
    fillChartData() {
      this.defaultChart.chartData = {
        datasets: [
          {
            fill: false,
            borderColor: chartConfig.chartColors.default.primary,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: chartConfig.chartColors.default.primary,
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: chartConfig.chartColors.default.primary,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: this.randomChartData(9),
          },
          {
            fill: false,
            borderColor: chartConfig.chartColors.default.info,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: chartConfig.chartColors.default.info,
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: chartConfig.chartColors.default.info,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: this.randomChartData(9),
          },
          {
            fill: false,
            borderColor: chartConfig.chartColors.default.danger,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: chartConfig.chartColors.default.danger,
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: chartConfig.chartColors.default.danger,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: this.randomChartData(9),
          },
        ],
        labels: ['01', '02', '03', '04', '05', '06', '07', '08', '09'],
      };
    },
  },
};
</script>
<style scoped>
.has-table h1{
  text-align: center;
  font-weight: bold;
}
.container h1{
  text-align: center;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 25px;;
}
.column-div{
  flex-grow: 1;
}
.col-items{
  margin-top: 10px;
}
/* .has-table{
  width: 70%;
  margin: auto;
} */
</style>